import useTitle from "./useTitle";

export default function Title() {
    const title = useTitle();
    return (
        <h1
            title={title}
            className="text-h2 text-compendia-foreground min-w-0 truncate font-medium md:text-2xl"
        >
            {title}
        </h1>
    );
}
